/**
 * otpauth:// URI helpers (commit 4 of the admin-MFA arc).
 *
 * Pure string functions — no React, no DOM — so they unit-test
 * under node:test (the repo convention) even though they live in
 * the admin app. The enrollment screen renders the QR from the
 * full URI and surfaces the parsed secret for manual entry into
 * an authenticator that can't scan.
 */

/** Extract the base32 secret from an otpauth:// URI. Returns null
 *  for anything that isn't a well-formed otpauth URI with a secret
 *  param — the screen falls back to QR-only enrollment rather than
 *  rendering a broken manual-entry box. */
export function secretFromOtpAuthUri(uri: string): string | null {
  if (!uri.startsWith('otpauth://')) return null;
  try {
    const parsed = new URL(uri);
    const secret = parsed.searchParams.get('secret');
    return secret && secret.length > 0 ? secret : null;
  } catch {
    return null;
  }
}

/** Space the base32 secret into 4-char groups for readability
 *  (authenticator manual-entry fields ignore whitespace). */
export function formatSecretForDisplay(secret: string): string {
  return secret.replace(/(.{4})/g, '$1 ').trim();
}
